import { Result } from '@blade/std-lib'
import { joinedInviteCodeAtom } from '@root/entities/referral'
import { DEMO_MODE, environmentAtom, PlatformUtil } from '@root/shared'
import { reatomRequest } from '@root/shared/lib'
import { TgUtil } from '@root/shared/lib/telegram'
import { showErrorSnackbarAction } from '@root/shared/ui'

import { TelegramLocalAuthData } from '../model'

import { generateTelegramTokenRequestAction } from './telegram-requests'

import type { TelegramAuthAction } from '../model'

export const reatomTelegramAuthentication = (action?: TelegramAuthAction) => {
  return reatomRequest({
    execAction: generateTelegramTokenRequestAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'reatomTelegramToken',
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showErrorSnackbarAction(ctx, result.failure)
        return
      }
      const { token } = result.success
      const joinedInviteCode = ctx.get(joinedInviteCodeAtom)

      const { buybotUsername } = ctx.get(environmentAtom)
      const data: TelegramLocalAuthData.TelegramLocalAuthData = {
        token,
        action,
        referralCode: joinedInviteCode,
      }

      const params = [`auth_${token}`, action ? `action_${action}` : undefined]
        .filter(Boolean)
        .join('_')

      const botLink = TgUtil.createTelegramLink(
        `${buybotUsername}?start=${params}`,
      )
      TelegramLocalAuthData.set(data)

      if (DEMO_MODE) {
        window.location.replace(
          `${window.location.origin}/tg-auth?code=${token}&isExists=${Math.random() > 0.5 ? 'true' : 'false'}`,
        )
        return
      }
      PlatformUtil.openLink(botLink)
    },
  })
}
